import React from 'react';
import { DateTime } from 'luxon';
import { Fieldset, Input } from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../../../Context';
import { Asterisk } from '../../../Asterisk';
import { getNextYear, toISODate } from '../../../../../helpers/dateTime';

const VoucherFormValidUntil: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const {
    formState: {
      payload: { validSince, validUntil },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  const dateObject = validUntil ? DateTime.fromISO(validUntil) : null;

  return (
    <Fieldset itemSpacing='half'>
      <Input
        name='date-field-validUntil'
        id='date-field-validUntil'
        label={<>Voucher valid until {!disabled && <Asterisk />}</>}
        type='date'
        min={validSince}
        disabled={disabled}
        required
        value={dateObject ? dateObject.setLocale('de').toFormat('yyyy-MM-dd') : ''}
        onChange={e => {
          const { value } = e.target;

          if (value === '') {
            handlePayloadChange({
              value: getNextYear(),
              prop: 'validUntil',
            });
          } else {
            const date = new Date(value);
            handlePayloadChange({
              value: toISODate(DateTime.fromJSDate(date)),
              prop: 'validUntil',
            });
          }
        }}
      />
    </Fieldset>
  );
};

export default VoucherFormValidUntil;
